import styles from './index.module.scss';
import { useFm } from '@web3/base-hooks';
import { Event } from '@/config/track-config';
import { scTrack } from '@web3/base-tracking';
import ArrowRight from '@/assets/images/bybitsol/arrow-right.svg';
import { isApp } from '@/utils/common';
import { bybitHecate } from '@web3/base-utils';
import { appPath } from '@web3/base-utils';
import { useParams, getScreenType } from '@web3/base-hooks';

export const EarnSteps = () => {
  const fm = useFm();

  const { locale } = useParams();

  const handleToStake = () => {
    const { isMobile } = getScreenType();
    if (isMobile) {
      if (isApp()) {
        bybitHecate('Router', 'push', {
          path: 'bybitapp://open/route?targetUrl=by-mini://web3_applet/earn/stake/pool_detail?poolId=77',
        });
      } else {
        const webUrl = `${origin}/${locale}${appPath}/pool/77`;
        const appTargetUrl =
          'bybitapp://open/route?targetUrl=by-mini://web3_applet/earn/stake/pool_detail?poolId=77';
        const appUrl = `bybitapp://open/route?targetUrl=${encodeURIComponent(appTargetUrl)}`;
        const link = `https://bybit.onelink.me/EhY6?af_web_dp=${encodeURIComponent(webUrl)}&c=staking_h5&af_dp=${encodeURIComponent(appUrl)}&af_force_deeplink=true`;
        window.top?.open(link);
      }
      return;
    }
    window.location.href = `${origin}/${locale}${appPath}/pool/77`;
  };

  const steps = [
    {
      icon: `${appPath}/png/bybitsol/step1.png`,
      title: fm('stepNum', { num: 1 }),
      subtitle: fm('stakeSolInBybit'),
      onClick: () => {
        scTrack(Event.Web3UserClick, {
          page_name: 'StakingWeb_BBSOLhomepage',
          button_name: 'step1',
        });
        handleToStake();
      },
      btnShow: true,
    },
    {
      icon: `${appPath}/png/bybitsol/step2.png`,
      title: fm('stepNum', { num: 2 }),
      subtitle: fm('leverageBbSOLAcrossCdP'),
      onClick: () => {
        scTrack(Event.Web3UserClick, {
          page_name: 'StakingWeb_BBSOLhomepage',
          button_name: 'step2',
        });
        const { isMobile } = getScreenType();
        const domId = isMobile ? 'bbsolSlidesMobile' : 'bbsolSlides';
        const dom = document?.getElementById(domId);

        if (dom) {
          dom.scrollIntoView({ behavior: 'smooth' });
        }
      },
      btnShow: true,
    },
    {
      icon: `${appPath}/png/bybitsol/step3.png`,
      title: fm('stepNum', { num: 3 }),
      subtitle: fm('redeemBbSOLToReceiveSOL'),
      onClick: () => {
        scTrack(Event.Web3UserClick, {
          page_name: 'StakingWeb_BBSOLhomepage',
          button_name: 'step2',
        });
        handleToStake();
      },
      btnShow: true,
    },
  ];

  return (
    <div className={styles.earn}>
      <p className={styles.earn__title}>{fm('startEarningInSteps')}</p>

      <div className={styles.earn__steps}>
        {steps.map((step) => (
          <div key={step.title} className={styles.earn__step}>
            <div className={styles.earn__step_icon}>
              <img src={step.icon} alt="" className={styles.earn__step_image} />
            </div>
            <div className={styles.earn__step_content}>
              <h4 className={styles.earn__step_title}>{step.title}</h4>
              <p className={styles.earn__step_subtitle}>{step.subtitle}</p>
              {step.btnShow && (
                <div
                  className={styles.earn__step_button}
                  onClick={step.onClick}
                >
                  {fm('viewMore')}
                  <ArrowRight />
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
